<template>
    <div class="login login-v2" data-pageload-addclass="animated fadeIn">
      <!-- begin brand -->
      <div class="auth-login">
        <div class="brand">
          <span class="logo"><img src="/assets/img/logo/p2c_logo.jpg"></span>
        </div>
      </div>
      <div class="login-content">
        <form class="margin-bottom-0">
          <form-group-thux
            :validator="$v.form.email"
            :label="'auth.email' | translate">
            <template slot-scope="{ attrs, listeners }">
              <b-form-input
                type="email"
                v-bind="attrs"
                v-on="listeners"
                v-model="form.email" />
            </template>
          </form-group-thux>
          <form-group-thux
            :validator="$v.form.password"
            :label="'auth.password' | translate">
            <template slot-scope="{ attrs, listeners }">
              <b-form-input
                type="password"
                v-bind="attrs"
                v-on="listeners"
                v-model="form.password" />
            </template>
          </form-group-thux>
          <div class="login-buttons mt-5">
            <button
              class="btn btn-success btn-block btn-lg"
              :disabled="$v.form.$invalid"
              @click.prevent="onSubmit()">
               {{ 'Login' | translate }}
            </button>
          </div>
          <div class="m-t-20">
            {{ 'auth.forgotPassword' | translate}}? {{ 'Click' | translate }} <router-link :to="{ name: AUTH_ROUTES.FORGOT_PASSWORD}">{{'here' | translate }}</router-link>.
          </div>
        </form>
      </div>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import PageOptions from '../../config/PageOptions.vue'
import { ROUTES as AUTH_ROUTES } from './router'
import { TYPES as AUTH_TYPES } from './store'

export default {
  name: 'Login',
  data () {
    return {
      form: {},
      AUTH_ROUTES
    }
  },
  created () { },
  beforeRouteLeave (to, from, next) {
    PageOptions.pageEmpty = false
    next()
  },
  methods: {
    ...mapActions({
      ...AUTH_TYPES.AUTH
    }),
    onSubmit () {
      if (!this.$v.$invalid) {
        this.login(this.form).then(
          response => {
            this.$router.replace({ path: '/' })
          }
        ).catch(
          error => {
            this.$store.dispatch('notifyError', { error: error.response.data })
          }
        )
      }
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  }
}
</script>
